<template>
  <div class="menu">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">Menu Principal</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav>
      <!-- Item Menu Inicio -->

      <v-list-item link to="/documentos/doc">
        <v-list-item-icon>
          <v-icon>fa-file-alt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Documentos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

       <v-list-item link to="/documentos/legislacao">
        <v-list-item-icon>
          <v-icon>fa-balance-scale</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Legislações</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/licitacoes">
        <v-list-item-icon>
          <v-icon>fa-list-alt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Licitações</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/prejulgados">
        <v-list-item-icon>
          <v-icon>fa-gavel</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Prejulgados</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/sumulas">
        <v-list-item-icon>
          <v-icon>fa-file-signature</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Súmulas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/convenios">
        <v-list-item-icon>
          <v-icon>fa-handshake</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Convênios</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/sancoes">
        <v-list-item-icon>
          <v-icon>fa-user-times</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Sanções</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link @click="logout()" style="color:red;">
        <v-list-item-icon>
          <v-icon style="color:red;">fa-sign-out-alt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color:red;">Sair</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Fim Menu  -->
    </v-list>
  </div>
</template>

<script>
export default {

  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    relatorios () {
      this.$router.push("/");
    }
  }

}
</script>

<style>
.mytable td {
    cursor: pointer;
} 
</style>